import { sortByDate } from "../functions/sortByDate";
import useSourceFlowCollection from "./useSourceFlowCollection";
import data from "../.sourceflow/teaching_jobs.json";

export const useTeachingJobs = ({ limit = null } = {}) => {
  const collection = sortByDate(useSourceFlowCollection(data), "publish_date");

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useTeachingJobs;
